module.exports = __webpack_public_path__ + "static/yahoo_calendar_3-819d87bb2b62aa0309580f20d84be497.png";